import request from '@/utils/request'

const dataObj = {
	version: '1.0',
	nonceStr: '1212fsadf',
	timestamp: '2020-4-21',
	signType: 'md5',
	content: { object: { merchantId: 1 } },
	sign: 'dafdsf'
}

export const getLinkConfig = () => {
	return request({
		url: '/api/v1/message/get-message-config',
		params: { ...dataObj }
	})
}
// 查询门列表分页
export const getDoors = (content = {}) => {
	return request({
		url: '/app/v1/dc/door/listByPage',
		params: { ...dataObj, content },
		mock: true
	})
}
// 查询设备信息
export const getAllTerminalType = (content = {}) => {
	return request({
		url: '/app/v1/dc/terminal/getAllTerminalType',
		params: { ...dataObj, content },
		mock: true
	})
}
// 上传参数
export const pushData = (content) => {
	return request({
		url: '/app/v1/dc/pushData/push',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 新增门
export const addDoor = (content) => {
	return request({
		url: '/app/v1/dc/door/add',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 修改门
export const updateDoor = (content) => {
	return request({
		url: '/app/v1/dc/door/update',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 删除门
export const deleteDoor = (content) => {
	return request({
		url: '/api/v2/door/remove',
		method: 'post',
		data: { ...dataObj, content: content.id },
		mock: true
	})
}
// 远程正常开门
export const openDoor = (content) => {
	return request({
		url: '/app/v1/dc/door/openDoor',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 保存门的设置
export const saveDoorSet = (content) => {
	return request({
		url: '/app/v1/dc/door/saveDoorSet',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 远程控制门
export const changeDoor = (content) => {
	return request({
		url: '/app/v1/dc/door/changeDoor',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 根据id查询门信息
export const getDoorDetail = ({ id }) => {
	return request({
		url: `/app/v1/dc/door/get/${id}`,
		params: { ...dataObj, id },
		mock: true
	})
}

// 楼宇
// 根据参数获取楼宇列表
export function getPageByParams (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/app/v1/dc/build/getPageByParams',
		method: 'get',
		params: obj,
		mock: true
	})
}
// 获取树结构楼宇数据
export const getBuildTree = (content = {}) => {
	return request({
		url: '/app/v1/dc/build/getTree',
		params: { ...dataObj, content },
		mock: true
	})
}
// 获取楼宇信息
export const getBuildById = ({ id }) => {
	return request({
		url: `/app/v1/dc/build/getById/${id}`,
		params: { ...dataObj },
		mock: true
	})
}
// 修改楼宇信息
export const updateBuildById = (content) => {
	return request({
		url: '/app/v1/dc/build/updateById',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 删除楼宇信息
export const deleteBuildById = (content = {}) => {
	return request({
		url: `/app/v1/dc/build/deleteById/${content}`,
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 删除门
export const deleteDoorById = (content = {}) => {
	return request({
		url: `/app/v1/dc/door/delete/${content}`,
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 新增楼宇
export const addBuild = (content) => {
	return request({
		url: '/app/v1/dc/build/add',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 获取所有终端机
export const getAllTerminals = (content = {}) => {
	return request({
		url: '/app/v1/dc/terminal/getAll',
		params: { ...dataObj, content },
		mock: true
	})
}
// 查看日志数量
export const getTerminals = (content = {}) => {
	return request({
		url: '/app/v1/dc/terminal/getDcTerminalsByPage',
		params: { ...dataObj, content },
		mock: true
	})
}
// 查看日志数量
export const getLogNumByIds = (content = {}) => {
	return request({
		url: '/app/v1/dc/terminal/getLogNumByIds',
		params: { ...dataObj, content },
		mock: true
	})
}
// 下载进出记录
export const downloadLogs = (content = {}) => {
	return request({
		url: '/app/v1/dc/terminal/downloadLogsByIds',
		params: { ...dataObj, content },
		mock: true
	})
}
export const addTerminal = (content) => {
	return request({
		url: '/app/v1/dc/terminal/add',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
export const updateTerminal = (content) => {
	return request({
		url: '/app/v1/dc/terminal/editById',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
export const deleteTerminal = ({ id }) => {
	return request({
		url: `/app/v1/dc/terminal/delete/${id}`,
		method: 'post',
		data: { ...dataObj },
		mock: true
	})
}
// 获取设备时间
export const getTerminalDate = (content = {}) => {
	return request({
		url: '/app/v1/dc/terminal/getDateByIds',
		params: { ...dataObj, content },
		mock: true
	})
}
// 重启设备
export const restartTerminal = (content = {}) => {
	return request({
		url: '/app/v1/dc/terminal/restartByIds',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 更新设备时间
export const updateTerminalDate = (content = {}) => {
	return request({
		url: '/app/v1/dc/terminal/setDateByIds',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 设置设备自动校时
export const setTerminalAutoDate = (content = {}) => {
	return request({
		url: '/app/v1/dc/terminal/setAutoTiming',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 查询自动校时设置
export const getAutoTiming = (content = {}) => {
	return request({
		url: '/app/v1/dc/terminal/getAutoTiming',
		params: { ...dataObj, content },
		mock: true
	})
}
// 获取设备配置
export const getTerminalConfig = ({ id }) => {
	return request({
		url: `/app/v1/dc/terminal/getById/${id}`,
		params: { ...dataObj, id },
		mock: true
	})
}
// 修改终端机配置
export const updateTerminalConfig = (content = {}) => {
	return request({
		url: '/app/v1/dc/terminal/editTerminalData',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}

// 分页查询人员权限
export const getCustDoor = (content = {}) => {
	return request({
		url: '/app/v1/dc/custDoorPwd/listByPage',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}

// 推送人员权限
export const pushUserRole = (content = {}) => {
	return request({
		url: '/app/v1/dc/custDoorPwd/pushUser',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}

// 删除终端机人员信息
export const delUserRole = (content = {}) => {
	return request({
		url: '/app/v1/dc/custDoorPwd/deleteUserByIds',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}

// 删除终端机全部人员信息
export const delAllUserRole = (content = {}) => {
	return request({
		url: '/app/v1/dc/custDoorPwd/deleteAllUsers',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}

// 根据客户id查询人员权限
export const getRoleByCustId = (content = {}) => {
	return request({
		url: `/app/v1/dc/custDoorPwd/getByCustId/${content}`,
		params: { ...dataObj, content },
		mock: true
	})
}

// 编辑人员权限
export const editCustDoorPwd = (content = {}) => {
	return request({
		url: '/app/v1/dc/custDoorPwd/edit',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}

// 清空设备进出记录
export const deleteLogs = (content = {}) => {
	return request({
		url: '/app/v1/dc/terminal/deleteLogsByIds',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}

// 时段
// 查询所有的时段信息
export const getTimeSetList = (content = {}) => {
	return request({
		url: '/app/v1/dc/timeSet/list',
		params: { ...dataObj, content },
		mock: true
	})
}
// 批量删除时段信息
export const plDeleteTimeSetByIds = (content = {}) => {
	return request({
		url: '/app/v1/dc/timeSet/deleteByIds',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 查询时段列表分页
export const getTimeSetListByPage = (content = {}) => {
	return request({
		url: '/app/v1/dc/timeSet/listByPage',
		params: { ...dataObj, content },
		mock: true
	})
}
// 修改时段信息
export const updateTimeSet = (content = {}) => {
	return request({
		url: '/app/v1/dc/timeSet/update',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 批量删除群组
export const plDeleteGroup = (content = {}) => {
	return request({
		url: '/app/v1/dc/holiday/deleteByIds',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 批量删除群组
export const plDeleteGroupList = (content = {}) => {
	return request({
		url: '/app/v1/dc/group/deleteList',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 获取所有群组信息
export const getGroupList = (content = {}) => {
	return request({
		url: '/app/v1/dc/group/list',
		params: { ...dataObj, content },
		mock: true
	})
}
// 分页查询群组
export const getGroupListByPage = (content = {}) => {
	return request({
		url: '/app/v1/dc/group/listByPage',
		params: { ...dataObj, content },
		mock: true
	})
}
// 更新群组信息
export const updateGroup = (content = {}) => {
	return request({
		url: '/app/v1/dc/group/updateById',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 删除群组
export const deleteGroup = (content = {}) => {
	return request({
		url: `/app/v1/dc/group/delete/${content.id}`,
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 新增群组
export const addGroup = (content = {}) => {
	return request({
		url: '/app/v1/dc/group/add',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 删除时段信息
export const deleteTimeSet = ({ id }) => {
	return request({
		url: `/app/v1/dc/timeSet/delete/${id}`,
		method: 'post',
		data: { ...dataObj },
		mock: true
	})
}
// 根据id查询群组
export const getGroupById = (content = {}) => {
	return request({
		url: `/app/v1/dc/group/get/${content}`,
		params: { ...dataObj, content },
		mock: true
	})
}
// 新增时段
export const addTimeSet = (content = {}) => {
	return request({
		url: '/app/v1/dc/timeSet/add',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 获取所有门的信息
export const getAllDoorList = (content = {}) => {
	return request({
		url: '/app/v1/dc/door/list',
		params: { ...dataObj, content },
		mock: true
	})
}
// 获取所有的时区信息
export const getAllTimeZoneList = (content = {}) => {
	return request({
		url: '/app/v1/dc/timeZone/list',
		params: { ...dataObj, content },
		mock: true
	})
}
// 获取时区详情数据
export const getTimeZoneDetail = (content = {}) => {
	return request({
		url: `/app/v1/dc/timeZone/getDetailById/${content}`,
		params: { ...dataObj, content },
		mock: true
	})
}
// 批量删除假日信息
export const plDeleteHoliday = (content = {}) => {
	return request({
		url: '/app/v1/dc/holiday/deleteByIds',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 分页查询假日
export const getHolidayListByPage = (content = {}) => {
	return request({
		url: '/app/v1/dc/holiday/listByPage',
		params: { ...dataObj, content },
		mock: true
	})
}
// 更新假日信息
export const updateHoliday = (content = {}) => {
	return request({
		url: '/app/v1/dc/holiday/update',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 删除假日信息
export const deleteHoliday = ({ id }) => {
	return request({
		url: `/app/v1/dc/holiday/delete/${id}`,
		method: 'post',
		data: { ...dataObj, id },
		mock: true
	})
}
// 新增群组
export const addHoliday = (content = {}) => {
	return request({
		url: '/app/v1/dc/holiday/add',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}

// 批量删除时区信息
export const plDeleteTimeZone = (content = {}) => {
	return request({
		url: '/app/v1/dc/timeZone/deleteByIds',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 分页查询时区
export const getTimeZoneListByPage = (content = {}) => {
	return request({
		url: '/app/v1/dc/timeZone/listByPage',
		params: { ...dataObj, content },
		mock: true
	})
}
// 根据ID删除时区
export const deleteTimeZone = (content = {}) => {
	return request({
		url: `/app/v1/dc/timeZone/delete/${content.id}`,
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 新增时区
export const addTimeZone = (content = {}) => {
	return request({
		url: '/app/v1/dc/timeZone/add',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 更新时区
export const updateTimeZone = (content = {}) => {
	return request({
		url: '/app/v1/dc/timeZone/update',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 获取门禁进出记录列表
export const getLogsByPage = (content = {}) => {
	return request({
		url: '/app/v1/dc/doorLog/getLogsByPage',
		params: { ...dataObj, content },
		mock: true
	})
}
// 获取门禁首末笔记录列表
export const getReportLogsByPage = (content = {}) => {
	return request({
		url: '/app/v1/dc/doorLog/getReportLogsByPage',
		params: { ...dataObj, content },
		mock: true
	})
}
// 获取数据交互日志
export const getOperateLogs = (content = {}) => {
	return request({
		url: '/app/v1/dc/doorLog/getOperateLogsByPage',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 根据门id获取人员信息
export const custDoorPwd = (content = {}) => {
	return request({
		url: '/app/v1/dc/custDoorPwd/listPageByDoor',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 分页查询自动分配规则
export const getAutoRule = (content = {}) => {
	return request({
		url: '/app/v1/dc/auto/rule/listByPage',
		params: { ...dataObj, content },
		mock: true
	})
}
// 查询自动分配规则详情
export const getAutoRuleDetail = (content = {}) => {
	return request({
		url: `/app/v1/dc/auto/rule/getDetailById/${content}`,
		params: { ...dataObj, content },
		mock: true
	})
}
// 添加自动分配规则
export const addAutoRule = (content = {}) => {
	return request({
		url: '/app/v1/dc/auto/rule/add',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 删除自动分配规则
export const delAutoRule = (content = {}) => {
	return request({
		url: `/app/v1/dc/auto/rule/deleteById/${content}`,
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 编辑自动分配规则
export const editAutoRule = (content = {}) => {
	return request({
		url: '/app/v1/dc/auto/rule/edit',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 实时图文监控设置
export const saveDisplayLog = (content = {}) => {
	return request({
		url: '/app/v1/dc/door/saveDisplayLog',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 刷新状态
export const terminalFlush = (content = {}) => {
	return request({
		url: '/app/v1/dc/terminal/flush',
		params: { ...dataObj, content },
		mock: true
	})
}
// 批量按门分配
export const plEditCustDoorPwd = (content = {}) => {
	return request({
		url: '/app/v1/dc/custDoorPwd/editList',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
// 重新推送失败人员
export const pushErrorCust = (content = {}) => {
	return request({
		url: '/app/v1/dc/custDoorPwd/push/error/cust',
		method: 'post',
		data: { ...dataObj, content },
		mock: true
	})
}
